// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { userSession } from "../observers/userObserver";

const ProtectedRoute = ({ allowedType, children }) => {

  const usertype = userSession.getUserType();

  if (usertype !== allowedType) {
    return <Navigate to="/restricted" replace />;
  }
  return children;
};

export default ProtectedRoute;
